import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  justify-content: center;
`;

export const OrganizationName = styled.div`
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 18px;
  color: #888;
`;

export const PageName = styled.div`
  font-size: 12px;
  margin-bottom: 16px;
  color: #888;
`;

export const QRCodeContainer = styled.div`
  border: 1px solid #ccc;
  padding: 16px;
  margin-bottom: 16px;
  width: 250px;
  height: 250px;
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
`;

export const QRCodeImage = styled.img`
  width: 250px;
  height: 250px;
  opacity: 0;
  transition:
    opacity 0.7s cubic-bezier(0.4, 0, 0.2, 1),
    box-shadow 0.7s cubic-bezier(0.4, 0, 0.2, 1);
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  box-shadow: 0 0 0px 0px #4fc3f7;
  &[data-loaded="true"] {
    opacity: 1;
    box-shadow: 0 0 24px 4px #4fc3f7;
  }
`;

export const PoweredBy = styled.div`
  font-size: 14px;
  color: #888;
`;
